import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      <div className="container">
        <div className="terms-content">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>Acceptance of Terms</h2>
            <p>By accessing or using this service, you agree to be bound by these Terms of Service. If you do not agree, please do not use our service.</p>
          </section>

          <section>
            <h2>Use of Service</h2>
            <p>You may use our service to create and interact with AI agents. You are responsible for maintaining the confidentiality of your account and for all activities that occur under your account.</p>
          </section>

          <section>
            <h2>User Content</h2>
            <p>You retain ownership of content you upload or create. By using our service, you grant us a license to use, store, and process your content to provide the service. You are responsible for ensuring you have the right to upload any content you provide.</p>
          </section>

          <section>
            <h2>Prohibited Uses</h2>
            <p>You may not use our service for any illegal purpose, to violate any laws, to infringe on others' rights, or to transmit harmful or malicious content. We reserve the right to suspend or terminate accounts that violate these terms.</p>
          </section>

          <section>
            <h2>Payment Terms</h2>
            <p>Some features require payment. All fees are non-refundable unless otherwise stated. We reserve the right to change our pricing with notice. Payments are processed through third-party payment processors.</p>
          </section>

          <section>
            <h2>Service Availability</h2>
            <p>We strive to provide reliable service but do not guarantee uninterrupted access. We may modify, suspend, or discontinue any part of the service at any time with or without notice.</p>
          </section>

          <section>
            <h2>Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, we are not liable for any indirect, incidental, or consequential damages arising from your use of the service. Our total liability is limited to the amount you paid us in the past 12 months.</p>
          </section>

          <section>
            <h2>Changes to Terms</h2>
            <p>We may modify these terms at any time. Continued use of the service after changes constitutes acceptance of the updated terms.</p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default TermsOfService;


